import { useEffect, useState } from 'react'
import { useToast } from "../../ui/use-toast"
import { getCsrfToken } from '../../utils/csrf'
import { CryptoInvestmentList, InvestmentList, TesouroDiretoInvestmentList } from '../models/ModelInvestments'

export const useInvestmentList = () => {
  const { toast } = useToast()
  const [investments, setInvestments] = useState<InvestmentList[]>([])
  const [cryptoInvestments, setCryptoInvestments] = useState<CryptoInvestmentList[]>([])
  const [tesouroDiretoInvestments, setTesouroDiretoInvestments] = useState<TesouroDiretoInvestmentList[]>([])
  const [selectedType, setSelectedType] = useState<string | null>(null)
  const [availableTypes, setAvailableTypes] = useState<Record<string, boolean>>({})

  useEffect(() => {
    const fetchAvailableTypes = async () => {
      try {
        const csrfToken = await getCsrfToken()
        const response = await fetch('/api/investments/list/', {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken,
            'X-Investment-Type': 'none'
          },
        })

        const data = await response.json()
        if (data.success) {
          setAvailableTypes(data.data.available_types)
        }
      } catch (error) {
        console.error('Error fetching investment types:', error)
      }
    }

    fetchAvailableTypes()
  }, [])

  const handleAssetTypeSelection = async (type: string) => {
    try {
      const csrfToken = await getCsrfToken()
      const response = await fetch('/api/investments/list/', {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
          'X-Investment-Type': type || 'none'
        },
      })

      const data = await response.json()
      
      if (data.success) {
        setSelectedType(type)
        if (type === 'stock') {
          setInvestments(data.data.investments || [])
        } else if (type === 'crypto') {
          setCryptoInvestments(data.data.crypto || [])
        } else if (type === 'tesouro_direto') {
          setTesouroDiretoInvestments(data.data.tesouro_direto || [])
        }
      }
    } catch (error) {
      console.error('Error fetching investments:', error)
      toast({
        title: "Error",
        description: "Failed to fetch investments. Please try again.",
        variant: "destructive",
      })
    }
  }

  return {
    investments,
    cryptoInvestments,
    tesouroDiretoInvestments,
    selectedType,
    handleAssetTypeSelection,
    availableTypes,
  }
}